/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Trigger_Space_RequiredInputs */



/**
* | output |
* | --- |
* | "Choose the connection whose events start this agent." |
*
* @param {Agent_Event_Trigger_Space_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_space_required = /** @type {((inputs?: Agent_Event_Trigger_Space_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_Space_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Verbindung, deren Ereignisse diesen Agenten starten.")
	return /** @type {LocalizedString} */ ("Choose the connection whose events start this agent.")
});